import PaymentMethodButton from './PaymentMethodButton';

export default PaymentMethodButton;
